import Vue from 'vue'

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

const assetUrl = document.getElementById("body").getAttribute("asset-url");
const loaderPng = assetUrl +'/images/loader/loader-2.png'
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {error: loaderPng, loading: loaderPng});

import LightBox from 'vue-image-lightbox'
Vue.component("lightbox", LightBox);

import VueCoreVideoPlayer from "vue-core-video-player";
Vue.use(VueCoreVideoPlayer);
